const REFERRER_KEY = 'aidivecoach_invite_referrer';

/** A share link that opens the inviter's welcome page — the inviter's user ID is the attribution. */
export const buildInviteLink = (inviterUserId: string): string =>
  `${window.location.origin}/invite/${encodeURIComponent(inviterUserId)}`;

export const storeReferrer = (inviterUserId: string): void => {
  try { localStorage.setItem(REFERRER_KEY, inviterUserId); } catch { /* storage unavailable — attribution is best-effort */ }
};

export const getStoredReferrer = (): string | null => {
  try { return localStorage.getItem(REFERRER_KEY); } catch { return null; }
};

export const clearStoredReferrer = (): void => {
  try { localStorage.removeItem(REFERRER_KEY); } catch { /* ignore */ }
};

/** A link the author sends to someone they tagged who isn't on the app: opens the claim page for exactly that tag. */
export const buildTagClaimLink = (postId: string, tagId: string, code: string): string =>
  `${window.location.origin}/tag/${encodeURIComponent(postId)}/${encodeURIComponent(tagId)}/${encodeURIComponent(code)}`;

const TAG_INVITES_EVENT = 'aidivecoach:show-tag-invites';

/** Asks the mounted TagInviteHost to open the share sheet for a post's not-yet-members. */
export const requestTagInvites = (postId: string): void => {
  window.dispatchEvent(new CustomEvent(TAG_INVITES_EVENT, { detail: { postId } }));
};

export const onTagInvitesRequested = (handler: (postId: string) => void): (() => void) => {
  const listener = (e: Event) => handler((e as CustomEvent<{ postId: string }>).detail.postId);
  window.addEventListener(TAG_INVITES_EVENT, listener);
  return () => window.removeEventListener(TAG_INVITES_EVENT, listener);
};
